<template>
    <Button icon="pi pi-save" :type="type" class="p-button-sm p-button-warning" />
</template>

<script>
    import { defineComponent } from 'vue'
    import Button from 'primevue/button';
    export default defineComponent({
        components: {
            Button,
        },
        props: {
            type: {
                type: String,
                default: 'submit',
            },
        }
    })
</script>
